// Auto-generated index of all Graphics components

import Canvas_Circles from "./Graphics/Canvas_Circles.jsx";
import Canvas_ClearRect from "./Graphics/Canvas_ClearRect.jsx";
import Canvas_Clipping from "./Graphics/Canvas_Clipping.jsx";
import Canvas_Compositing from "./Graphics/Canvas_Compositing.jsx";
import Canvas_Coordinates from "./Graphics/Canvas_Coordinates.jsx";
import Canvas_Curves from "./Graphics/Canvas_Curves.jsx";
import Canvas_Drawing from "./Graphics/Canvas_Drawing.jsx";
import Canvas_Examples from "./Graphics/Canvas_Examples.jsx";
import Canvas_Fill_Stroke from "./Graphics/Canvas_Fill_Stroke.jsx";
import Canvas_Images from "./Graphics/Canvas_Images.jsx";
import Canvas_Intro from "./Graphics/Canvas_Intro.jsx";
import Canvas_Linear_Gradient from "./Graphics/Canvas_Linear_Gradient.jsx";
import Canvas_Lines from "./Graphics/Canvas_Lines.jsx";
import Canvas_Radial_Gradient from "./Graphics/Canvas_Radial_Gradient.jsx";
import Canvas_Rectangles from "./Graphics/Canvas_Rectangles.jsx";
import Canvas_Shadows from "./Graphics/Canvas_Shadows.jsx";
import Canvas_Shapes from "./Graphics/Canvas_Shapes.jsx";
import Canvas_Text from "./Graphics/Canvas_Text.jsx";
import Canvas_Text_Alignment from "./Graphics/Canvas_Text_Alignment.jsx";
import Canvas_Text_Color from "./Graphics/Canvas_Text_Color.jsx";
import Canvas_Transformations from "./Graphics/Canvas_Transformations.jsx";
import Clock_Face from "./Graphics/Clock_Face.jsx";
import Clock_Hands from "./Graphics/Clock_Hands.jsx";
import Clock_Intro from "./Graphics/Clock_Intro.jsx";
import Clock_Numbers from "./Graphics/Clock_Numbers.jsx";
import Clock_Start from "./Graphics/Clock_Start.jsx";
import Game_Bouncing from "./Graphics/Game_Bouncing.jsx";
import Game_Canvas from "./Graphics/Game_Canvas.jsx";
import Game_Components from "./Graphics/Game_Components.jsx";
import Game_Controllers from "./Graphics/Game_Controllers.jsx";
import Game_Gravity from "./Graphics/Game_Gravity.jsx";
import Game_Images from "./Graphics/Game_Images.jsx";
import Game_Intro from "./Graphics/Game_Intro.jsx";
import Game_Movement from "./Graphics/Game_Movement.jsx";
import Game_Obstacles from "./Graphics/Game_Obstacles.jsx";
import Game_Rotation from "./Graphics/Game_Rotation.jsx";
import Game_Score from "./Graphics/Game_Score.jsx";
import Game_Sound from "./Graphics/Game_Sound.jsx";
import Graphics from "./Graphics/Graphics.jsx";
import Graphics_Home from "./Graphics/Graphics_Home.jsx";
import Maps_Basic from "./Graphics/Maps_Basic.jsx";
import Maps_Controls from "./Graphics/Maps_Controls.jsx";
import Maps_Events from "./Graphics/Maps_Events.jsx";
import Maps_Intro from "./Graphics/Maps_Intro.jsx";
import Maps_Overlays from "./Graphics/Maps_Overlays.jsx";
import Maps_Reference from "./Graphics/Maps_Reference.jsx";
import Maps_Types from "./Graphics/Maps_Types.jsx";
import Plot_Canvas from "./Graphics/Plot_Canvas.jsx";
import Plot_ChartJS from "./Graphics/Plot_ChartJS.jsx";
import Plot_D3JS from "./Graphics/Plot_D3JS.jsx";
import Plot_Google from "./Graphics/Plot_Google.jsx";
import Plot_Graphics from "./Graphics/Plot_Graphics.jsx";
import Plot_Plotly from "./Graphics/Plot_Plotly.jsx";
import SVG_Animation from "./Graphics/SVG_Animation.jsx";
import SVG_Blur_Effects from "./Graphics/SVG_Blur_Effects.jsx";
import SVG_Circle from "./Graphics/SVG_Circle.jsx";
import SVG_Clip_Mask from "./Graphics/SVG_Clip_Mask.jsx";
import SVG_Drop_Shadow_1 from "./Graphics/SVG_Drop_Shadow_1.jsx";
import SVG_Drop_Shadow_2 from "./Graphics/SVG_Drop_Shadow_2.jsx";
import SVG_Ellipse from "./Graphics/SVG_Ellipse.jsx";
import SVG_Examples from "./Graphics/SVG_Examples.jsx";
import SVG_Fill from "./Graphics/SVG_Fill.jsx";
import SVG_Filters_Intro from "./Graphics/SVG_Filters_Intro.jsx";
import SVG_Image from "./Graphics/SVG_Image.jsx";
import SVG_In_HTML from "./Graphics/SVG_In_HTML.jsx";
import SVG_Intro from "./Graphics/SVG_Intro.jsx";
import SVG_Line from "./Graphics/SVG_Line.jsx";
import SVG_Linear_Gradient from "./Graphics/SVG_Linear_Gradient.jsx";
import SVG_Links from "./Graphics/SVG_Links.jsx";
import SVG_Marker from "./Graphics/SVG_Marker.jsx";
import SVG_Path from "./Graphics/SVG_Path.jsx";
import SVG_Patterns from "./Graphics/SVG_Patterns.jsx";
import SVG_Polygon from "./Graphics/SVG_Polygon.jsx";
import SVG_Polyline from "./Graphics/SVG_Polyline.jsx";
import SVG_Quiz from "./Graphics/SVG_Quiz.jsx";
import SVG_Radial_Gradient from "./Graphics/SVG_Radial_Gradient.jsx";
import SVG_Rectangle from "./Graphics/SVG_Rectangle.jsx";
import SVG_Reference from "./Graphics/SVG_Reference.jsx";
import SVG_Scripting from "./Graphics/SVG_Scripting.jsx";
import SVG_Stroke from "./Graphics/SVG_Stroke.jsx";
import SVG_TextPath from "./Graphics/SVG_TextPath.jsx";
import SVG_Text_Tspan from "./Graphics/SVG_Text_Tspan.jsx";
import SVG_Transformations from "./Graphics/SVG_Transformations.jsx";

const graphicsComponentsMap = {
  "<Canvas_Circles />": Canvas_Circles,
  "<Canvas_ClearRect />": Canvas_ClearRect,
  "<Canvas_Clipping />": Canvas_Clipping,
  "<Canvas_Compositing />": Canvas_Compositing,
  "<Canvas_Coordinates />": Canvas_Coordinates,
  "<Canvas_Curves />": Canvas_Curves,
  "<Canvas_Drawing />": Canvas_Drawing,
  "<Canvas_Examples />": Canvas_Examples,
  "<Canvas_Fill_Stroke />": Canvas_Fill_Stroke,
  "<Canvas_Images />": Canvas_Images,
  "<Canvas_Intro />": Canvas_Intro,
  "<Canvas_Linear_Gradient />": Canvas_Linear_Gradient,
  "<Canvas_Lines />": Canvas_Lines,
  "<Canvas_Radial_Gradient />": Canvas_Radial_Gradient,
  "<Canvas_Rectangles />": Canvas_Rectangles,
  "<Canvas_Shadows />": Canvas_Shadows,
  "<Canvas_Shapes />": Canvas_Shapes,
  "<Canvas_Text />": Canvas_Text,
  "<Canvas_Text_Alignment />": Canvas_Text_Alignment,
  "<Canvas_Text_Color />": Canvas_Text_Color,
  "<Canvas_Transformations />": Canvas_Transformations,
  "<Clock_Face />": Clock_Face,
  "<Clock_Hands />": Clock_Hands,
  "<Clock_Intro />": Clock_Intro,
  "<Clock_Numbers />": Clock_Numbers,
  "<Clock_Start />": Clock_Start,
  "<Game_Bouncing />": Game_Bouncing,
  "<Game_Canvas />": Game_Canvas,
  "<Game_Components />": Game_Components,
  "<Game_Controllers />": Game_Controllers,
  "<Game_Gravity />": Game_Gravity,
  "<Game_Images />": Game_Images,
  "<Game_Intro />": Game_Intro,
  "<Game_Movement />": Game_Movement,
  "<Game_Obstacles />": Game_Obstacles,
  "<Game_Rotation />": Game_Rotation,
  "<Game_Score />": Game_Score,
  "<Game_Sound />": Game_Sound,
  "<Graphics />": Graphics,
  "<Graphics_Home />": Graphics_Home,
  "<Maps_Basic />": Maps_Basic,
  "<Maps_Controls />": Maps_Controls,
  "<Maps_Events />": Maps_Events,
  "<Maps_Intro />": Maps_Intro,
  "<Maps_Overlays />": Maps_Overlays,
  "<Maps_Reference />": Maps_Reference,
  "<Maps_Types />": Maps_Types,
  "<Plot_Canvas />": Plot_Canvas,
  "<Plot_ChartJS />": Plot_ChartJS,
  "<Plot_D3JS />": Plot_D3JS,
  "<Plot_Google />": Plot_Google,
  "<Plot_Graphics />": Plot_Graphics,
  "<Plot_Plotly />": Plot_Plotly,
  "<SVG_Animation />": SVG_Animation,
  "<SVG_Blur_Effects />": SVG_Blur_Effects,
  "<SVG_Circle />": SVG_Circle,
  "<SVG_Clip_Mask />": SVG_Clip_Mask,
  "<SVG_Drop_Shadow_1 />": SVG_Drop_Shadow_1,
  "<SVG_Drop_Shadow_2 />": SVG_Drop_Shadow_2,
  "<SVG_Ellipse />": SVG_Ellipse,
  "<SVG_Examples />": SVG_Examples,
  "<SVG_Fill />": SVG_Fill,
  "<SVG_Filters_Intro />": SVG_Filters_Intro,
  "<SVG_Image />": SVG_Image,
  "<SVG_In_HTML />": SVG_In_HTML,
  "<SVG_Intro />": SVG_Intro,
  "<SVG_Line />": SVG_Line,
  "<SVG_Linear_Gradient />": SVG_Linear_Gradient,
  "<SVG_Links />": SVG_Links,
  "<SVG_Marker />": SVG_Marker,
  "<SVG_Path />": SVG_Path,
  "<SVG_Patterns />": SVG_Patterns,
  "<SVG_Polygon />": SVG_Polygon,
  "<SVG_Polyline />": SVG_Polyline,
  "<SVG_Quiz />": SVG_Quiz,
  "<SVG_Radial_Gradient />": SVG_Radial_Gradient,
  "<SVG_Rectangle />": SVG_Rectangle,
  "<SVG_Reference />": SVG_Reference,
  "<SVG_Scripting />": SVG_Scripting,
  "<SVG_Stroke />": SVG_Stroke,
  "<SVG_TextPath />": SVG_TextPath,
  "<SVG_Text_Tspan />": SVG_Text_Tspan,
  "<SVG_Transformations />": SVG_Transformations,
};

export default graphicsComponentsMap;
